/* ============================================================
   Article Summary — scroll-spy (design Claude)
   Met en surbrillance l'entrée du sommaire correspondant à la
   section actuellement visible.
   ============================================================ */
(function () {
  function initToc(toc) {
    var links = Array.prototype.slice.call(toc.querySelectorAll('[data-toc-link]'));
    if (!links.length) return;

    var targets = links
      .map(function (link) {
        var id = link.getAttribute('data-toc-link');
        var el = id ? document.getElementById(id) : null;
        return el ? { id: id, el: el, link: link } : null;
      })
      .filter(Boolean);

    if (!targets.length) return;

    var offset = 140;
    var current = null;
    var ticking = false;

    function update() {
      ticking = false;
      var active = targets[0];
      for (var i = 0; i < targets.length; i++) {
        if (targets[i].el.getBoundingClientRect().top <= offset) {
          active = targets[i];
        }
      }
      if (active === current) return;
      if (current) current.link.classList.remove('is-active');
      active.link.classList.add('is-active');
      active.link.setAttribute('aria-current', 'true');
      if (current) current.link.removeAttribute('aria-current');
      current = active;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  function init() {
    document.querySelectorAll('[data-article-toc]').forEach(initToc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
